import { ENV } from '@aloft/toolkit-shared';

import { getConfig } from './getConfig.js';

export function whatEnv(): ENV {
  const env = getConfig('ENVIRONMENT') as ENV;
  if (!env) {
    throw Error('Failed to lookup environment');
  }
  return env;
}
